// extracted by mini-css-extract-plugin
export default {"card_header":"card_card_header__QpKAw","card_h_back_button":"card_card_h_back_button__sGWfh","card_h_heading":"card_card_h_heading__YmuQH"};